import React from "react";

// Child Component: IntroProductSection
const IntroProductSection = ({
  imageSrc,
  altText,
  heading,
  description,
  points,
}) => {
  return (
    <section
      className="w-full"
      style={{
        minHeight: "550px",
        height: "auto",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className="flex flex-col md:flex-row items-center md:items-stretch gap-8 py-8 md:py-2 max-w-screen-xl mx-auto px-1 sm:px-2 h-full w-full">
        {/* Left: Product Image */}
        <div className="w-full md:w-1/2 flex justify-center items-center relative mb-8 md:mb-0 h-full">
          <img
            src={imageSrc}
            alt={altText}
            className="object-cover "
            style={{
              width: "100%",
              height: "420px",
              maxWidth: "100%",
              borderRadius: ".5rem",
              boxShadow: "0 10px 38px 0 rgba(0,0,0,0.06)",
              objectFit: "fill",
            }}
          />
          {/* Optionally: Overlay for a touch of glass effect */}
          {/* <div className="absolute z-10 inset-0 bg-white bg-opacity-10 rounded-2xl pointer-events-none" /> */}
        </div>

        {/* Right: Content */}
        <div className="w-full md:w-1/2 flex flex-col justify-center pl-0 md:pl-1">
          {/* Heading */}
          <h2 className="main-heading-font-size text-[#181C32] mb-5 font-semibold leading-snug max-w-xl">
            {heading}
          </h2>
          {/* Description */}
          <p className="text-gray-700 mb-8 text-lg max-w-2xl leading-relaxed">
            {description}
          </p>

          {/* Feature Points */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
            {points.map((point, idx) => (
              <div
                key={idx}
                className="flex flex-row items-center gap-2 bg-white rounded-xl h-full justify-between transition-shadow duration-200 min-h-[150px]"
              >
                <div className="h-14 w-14 flex items-center justify-center mb-3">
                  <img
                    src={point.icon}
                    alt={`${point.title} Icon`}
                    className="w-12 h-12 object-contain gif-color-change"
                    style={{
                      width: "48px",
                      height: "48px",
                    }}
                  />
                </div>
                <h3 className="font-semibold text-lg text-[#172342] text-left py-2 mb-2">
                  {point.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export { IntroProductSection };
